import React from 'react';
import { motion } from 'framer-motion';
import { CountdownBanner } from './CountdownBanner';
export function Nav() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 shadow-sm" data-id="element-234" data-mp="120pednn6tt77">
      <CountdownBanner data-id="element-235" data-mp="1b0ck2lmy9l62" />
    </motion.nav>;
}